/*
 * Number field component
 */
import React from 'react';

import {
  TextField,
} from '../form_components';

import {
  DataType,
  NumberFormatting
} from '../common.jsx'

export default class NumberField extends TextField {

    static get TYPE() {
        return 'number_field';
    }

    static icon(){
        return <i className='fa fa-i-cursor'></i>;
    }


    static compatiblePrefillComponents() {
      return ['number_field'];
    }
  
    static compatiblePrefillDataTypes() {
      return [DataType.INTEGER, DataType.DECIMAL];
    }

    static defaultContent(language) {
        return Object.assign(super.defaultContent(language), {
            dataType: DataType.INTEGER,
            numberFormatting: NumberFormatting.NUMBER
        });
    }

    getAvailableDataTypeOptions() {
        return [DataType.INTEGER, DataType.DECIMAL]
    }

    getAvailableNumberFormattingOptions() {
        return [NumberFormatting.NONE, NumberFormatting.NUMBER, NumberFormatting.CURRENCY]
    }
}
